import { CSV_FILE_TYPE, XLSX_FILE_TYPE } from 'utils/constants';

export const getReportFileFormat = ({ type }: Blob) => {
  if (type === XLSX_FILE_TYPE) return '.xlsx';
  if (type === CSV_FILE_TYPE) return '.csv';

  return '';
};
